import * as React from 'react';
import { ArticleParagraph2 } from '@cian/ui-kit';
import { IconFunctionalWarningSign16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './styles.css';
import cn from 'clsx';
import { useIsDesktop } from '@cian/valuation-utils-component';

export const ValuationNotFound: React.FC = () => {
  const isDesktop = useIsDesktop();

  return (
    <div className={cn(styles['container'], isDesktop ? styles['container_desktop'] : styles['container_mobile'])}>
      <div className={styles['image']}>
        <IconFunctionalWarningSign16 />
      </div>
      <ArticleParagraph2>У нас пока нет оценки по этому адресу</ArticleParagraph2>
    </div>
  );
};

ValuationNotFound.displayName = 'ValuationNotFound';
